import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";

export const directoryRouteGuard: CanActivateFn = (route): true | UrlTree => {
    const router = inject(Router);
    const translocoService = inject(TranslocoService);

    const { slug, locale, typeSegment } = route.params;
    const directoryPathSegment = translocoService.translate("directoryPathSegment");
    const categoryPathSegment = translocoService.translate("categoryPathSegment");
    const supplierPathSegment = translocoService.translate("supplierPathSegment");

    const pathsMatch = (current: string[], expected: string[]) =>
        current.length === expected.length && current.every((segment, index) => segment === expected[index]);

    switch (typeSegment) {
        case categoryPathSegment: {
            route.data = { ...route.data, pageType: "category" };

            const expectedPath = [locale, directoryPathSegment, categoryPathSegment, slug];
            const currentPath = route.url.map((segment) => segment.path);

            if (pathsMatch(currentPath, expectedPath)) {
                return true;
            }

            return router.createUrlTree([...expectedPath]);
        }

        case supplierPathSegment: {
            route.data = { ...route.data, pageType: "supplier" };

            const expectedPath = [locale, directoryPathSegment, supplierPathSegment, slug];
            const currentPath = route.url.map((segment) => segment.path);

            if (pathsMatch(currentPath, expectedPath)) {
                return true;
            }

            return router.createUrlTree([...expectedPath]);
        }

        default:
            return router.createUrlTree([locale]);
    }
};
